module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Search-6d4367e6ffbb6c50f3fc5682f83aff76.svg";